import { render, staticRenderFns } from "./pageSem.vue?vue&type=template&id=56998091&"
import script from "./pageSem.vue?vue&type=script&lang=js&"
export * from "./pageSem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports